

export const CHANGE_COLOR = 'CHANGE_COLOR';

export const changeColor = function(color) {
	return dispatch => {

		dispatch({ type: CHANGE_COLOR, data: { color } });
	};
}


// WEBPACK FOOTER //
// ./src/actions/backgroundColor.js